module.exports = __webpack_public_path__ + "img/filete_al_ajillo.6ddf8716.jpg";